import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FiChecklist2ReportWidgetBaseDirective } from '@fi-shared/checklist/fi-checklist2-report/shared/fi-checklist2-report-widget-base.directive';
import { IChecklist2ReportChecklistSummary } from '@fi-shared/checklist/fi-checklist2-report/shared/fi-checklist2-report';
import { IReportWidget } from '@fi-shared/fi-report-widget/fi-report-widget';

@Component({
    selector: 'fi-open-checklists-widget',
    templateUrl: './open-checklists-widget.component.html',
    styleUrls: ['./open-checklists-widget.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-open-checklists-widget' },
    standalone: false,
})
export class FiOpenChecklistsWidgetComponent extends FiChecklist2ReportWidgetBaseDirective implements OnInit {
    protected filteredOpenChecklistDetails: IChecklist2ReportChecklistSummary[] = [];
    protected widgetData: IReportWidget;

    ngOnInit() {
        super.ngOnInit();
        this.filteredOpenChecklistDetails = [...this.reportData.getOpenChecklistsSummary(this.reportParameter.Id)];
        this.widgetData = {
            description: this.getWidgetDescription(),
            icon: 'far fa-ballot-check',
            summaryCount: this.getBusinessUnitsCount(),
        };
    }

    protected getWidgetDescription(): string {
        return (
            this.reportParameter.Description || this.appTextService.get('checklist.report_open_checklists_total_number')
        );
    }

    private getBusinessUnitsCount(): number {
        return this.filteredOpenChecklistDetails.reduce(
            (partialSum: number, item: IChecklist2ReportChecklistSummary) => partialSum + item.IterationsCount,
            0,
        );
    }
}
